/* eslint camelcase: 'off' */
import _fetchRX from './fetch';
import { postByForm } from '@patsnap/common-ps-http';
import { switchMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';

import get from 'lodash/get';
import map from 'lodash/map';
import getQueryFromUrl from '@/utils/getQueryFromUrl';
import { getViewParams } from 'library-@/utils/get-params';
import { getRealQueryApi } from 'library-@/apis/core_basic_api/shortener';
import { getPatentApi } from 'library-@/apis/core_basic_api/view';
import { HOME_SERVICE_URI } from 'library-@/config/apiConfig';

import {
    markApi,
    hasFigurePartsApi,
    getFiguresApi,
    getBasicByIdApi,
    getBasicByIdWithoutHighlightApi,
    patentViewInitTabApi
} from 'library-@/apis/core_basic_api/patent';
import { markWorkspaceApi } from 'library-@/apis/workspace_api/patents';
import { getCategoryDetailApi } from 'library-@/apis/core_basic_api/classification';

export const FROM_CHEMICAL = 'chemical';
export const FROM_BIO = 'bio';
export const excludes = ['hasValidHash', 'patentId', 'highlight'];
const HIGHLIGHT_ENABLE = true;
const ALERT_BASE_URL = `${HOME_SERVICE_URI}/email-alert-api`;

export const getParams = async (...rest) => {
    const viewParams = getViewParams(...rest);
    const { from_site } = viewParams;
    let data = { ...viewParams };
    const bio_uk = getQueryFromUrl('bio_uk');
    const uk = getQueryFromUrl('uk')
    if (from_site === FROM_BIO && bio_uk) {
        data.bio_uk = bio_uk
    }
    if (from_site === FROM_CHEMICAL && uk) {
        data.uk = uk
    }
    const params = { highlight: HIGHLIGHT_ENABLE };
    return { data, params };
};

export function constructFullParamsCallback(patentId) {
    return getParams({ excludes })
        .then(o => Object.assign(o, { patentId }));
}

function getBasicById(patentId) {
    return of(patentId)
        .pipe(
            switchMap(constructFullParamsCallback),
            switchMap(({ data, params, patentId }) => {
                return forkJoin([getBasicByIdApi(patentId, params, data), patentViewInitTabApi(patentId)]);
            })
        );
}

function getBasicByIdWithoutHighlight(patentId) {
    return of(patentId)
        .pipe(
            switchMap(patentId => {
                return getBasicByIdWithoutHighlightApi(patentId);
            })
        );
}

export const alignment = data => _fetchRX({
    url: '/bio/alignment',
    method: 'post',
    data,
    cache: true
});

const getList = options => {
    return getPatentApi(options).then(({ data: resp }) => {
        const page = get(resp, 'data.page');
        const list = get(resp, 'data.LIST') || [];
        if (page && list) {
            list.forEach(item => {
                item.onPage = page;
            });
        }
        return resp;
    });
};

const mark = patentId => {
    const markReqs = [markApi(patentId)];
    if (get(window, 'queryObj._type') === 'workspace') {
        markReqs.push(markWorkspaceApi({
            folder_id: get(window, 'queryObj.folder_id', ''),
            patent_ids: [patentId],
        }));
    }
    return Promise.all(markReqs);
};

const chemUKCache = {};
/**
 * FIXME: 这个逻辑需要 review 整理
 * 这个方法会自动从 url 中获取 uk 做查询，并且缓存查过的 uk，所以需要查询 uk 时不需要传入 uk，
 * 并且识别 uk 是 bio 的还是 chemical 的，目前 uk 有会在 bio 和 chemical 跳过来的时候会有，
 * 参数 from 是可选参数，如果想要过滤 uk 的结果，可以传入 from，可选值是 chemical 和 bio ,
 * 这样在返回时会判断如果不是从 from 过来的会返回空值
 * @param {*} from  [String], 可选值， 'chemical' 或 'bio'
 */
const getOriginChem = from => {
    const uk = getQueryFromUrl('uk') || getQueryFromUrl('bio_uk');
    let selectedQuery = [];
    let originQuery = [];
    if (uk) {
        if (chemUKCache[uk]) {
            return Promise.resolve(chemUKCache[uk]);
        }
        return getRealQueryApi(uk).then(data => {
            let query = get(data, 'query', '');
            query = query || '';
            let selected;
            let origin;
            let fromSite;
            if (query.indexOf('from_bio') !== -1) {
                fromSite = FROM_BIO;
                [, selected, origin] = query.split('&&');
                originQuery = [];
            } else {
                fromSite = FROM_CHEMICAL;
                [selected, origin] = query.split('&&');
                originQuery = [];
            }
            if (selected) {
                selectedQuery = selected.split(',');
            }
            if (origin) {
                // bio 过来的原始 query 只有一个，chemical 过来会有多个 inchiKey
                originQuery = origin.split(',');
            }
            chemUKCache[uk] = {
                fromSite,
                query: originQuery,
                selected: selectedQuery
            };
            if (!from || fromSite === from) {
                return {
                    fromSite,
                    query: originQuery,
                    selected: selectedQuery
                };
            }
            return {
                fromSite: 'none',
                query: [],
                selected: []
            };
        });
    }
    return Promise.resolve({
        fromSite: 'none',
        query: [],
        selected: []
    });
};

const getCategoryDetail = (type, name) => {
    return getCategoryDetailApi(type, name)
        .then(resp => resp.data || {})
};


const isDebug = (function () {
    let localVal = localStorage.getItem('tfDebug');
    return localVal === 'true' || localVal === '1';
})();

const isFallback = (function () {
    let localVal = localStorage.getItem('tfFallback');
    return localVal === 'true' || localVal === '1';
})();

if (isDebug) {
    console.warn(`Text Figure debug mode enabled
    Disable Debug: localStorage.removeItem('tfDebug');
    `);
}

if (!isFallback) {
    console.warn('Text Figure Fallback disabled');
}

const testHasFigureParts = function(patentId) {
    const params = {
        isDebug: isDebug ? 1 : 0,
        isFallback: isFallback ? 1 : 0
    }
    return hasFigurePartsApi(patentId, params).then(resp => resp.data);
};
function getFigures(patentId, imageUrl, box, lang, category, resolution, image_type, image_id, pn) {
    const data = {
        url: imageUrl,
        box,
        resolution,
        lang,
        isDebug: isDebug ? 1 : 0,
        isFallback: isFallback ? 1 : 0,
        category: category || '',
        image_type,
        image_id,
        pn
    }
    return getFiguresApi(patentId, imageUrl, box, data).then(resp => resp.data);
}

function phpUrlencode(str) {
    str = `${str}`;

    return encodeURIComponent(str)
        .replace(/!/g, '%21')
        .replace(/'/g, '%27')
        .replace(/\(/g, '%28')
        .replace(/\)/g, '%29')
        .replace(/\*/g, '%2A')
        .replace(/%20/g, '+');
}

// =获取所有的审查文件邮件提醒=
const getFileWrapperList = () => {
    return _fetchRX({
        url: `${ALERT_BASE_URL}/emailalert/alert/filewrapper`,
        method: 'get'
    }).then(result => {
        if (result.status) {
            return map(result.data, item => (
                {
                    ...item,
                    patentId: item.patent_id
                }
            ));
        }
        return [];
    });
};

// =创建审查文件邮件提醒=
const createFileWrapperAlert = param => {
    const data = {
        ...param,
        patent_id: param.patentId,
        email: get(window, 'zPREFACE.accountInfo.email', '') || get(window, 'zPREFACE.accountInfo.mobile_number', '')
    };
    delete data.patentId;

    return _fetchRX({
        url: `${ALERT_BASE_URL}/emailalert/alert/filewrapper`,
        data,
        method: 'post'
    });
};

// 【删除某个邮件提醒】
const deleteFileWrapperAlert = id => {
    return _fetchRX({
        url: `${ALERT_BASE_URL}/emailalert/alert/${id}`,
        method: 'DELETE'
    });
};

const semanticSearch = param => {
    postByForm(true, '/node-internal/search/input/search/semantic/jump', param);
};

export {
    getOriginChem,
    phpUrlencode,
    mark,
    getList,
    getBasicById,
    getBasicByIdWithoutHighlight,
    getCategoryDetail,
    testHasFigureParts,
    getFigures,
    getFileWrapperList,
    createFileWrapperAlert,
    deleteFileWrapperAlert,
    semanticSearch,
};
